<template>
  <div data-component="base-search-query-labels">
    <span
      v-for="(label, index) of queryParamLabels"
      :key="index"
      data-label="search-param-label"
    >
      <span class="text">{{ label }}</span>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import { useSearchQueryParam } from '../../composables';
import { PARAM_PROP, SCHEMA_PROP } from '../../constants';

export default defineComponent({
  name: 'BaseSearchQueryLabels',
  props: {
    param: PARAM_PROP,
    schema: SCHEMA_PROP,
  },
  setup(props) {
    const { queryParamLabels } = useSearchQueryParam(props);
    return { queryParamLabels };
  },
});
</script>

<style lang="scss" scoped>
@use '../../styles' as *;

[data-component='base-search-query-labels'] {
  @include base-search-query-tags;
}
</style>
